/** Path público do Movimento Wosi (não confundir com API `GET /blog/*` nem CMS `/minha-conta/blog`). */
export const PUBLIC_BLOG_PATH = 'movimento-wosi';
export const PUBLIC_BLOG_BASE = `/${PUBLIC_BLOG_PATH}`;

export function publicBlogHomePath(): string {
  return PUBLIC_BLOG_BASE;
}

export function publicBlogArticlePath(slug: string): string {
  return `${PUBLIC_BLOG_BASE}/${slug}`;
}

export function publicBlogPreviewPath(token: string): string {
  return `${PUBLIC_BLOG_BASE}/preview/${token}`;
}

export function publicBlogCategoryPath(categorySlug: string): string {
  return `${PUBLIC_BLOG_BASE}/categoria/${categorySlug}`;
}

/** `/blog` legado → `/movimento-wosi`. Não mexe em `/minha-conta/blog`. */
export function rewriteLegacyPublicBlogPath(pathWithQuery: string): string {
  return pathWithQuery.replace(/^\/blog(?=\/|$|\?|#)/, PUBLIC_BLOG_BASE);
}

export function isPublicBlogPath(path: string): boolean {
  const clean = path.split('?')[0]?.split('#')[0] ?? path;
  return (
    clean === PUBLIC_BLOG_BASE ||
    clean.startsWith(`${PUBLIC_BLOG_BASE}/`) ||
    clean === '/blog' ||
    clean.startsWith('/blog/')
  );
}
